export const generateKey = () =>
  parseInt((Date.now() * Math.random()).toString()).toString(16);
